/*
 * @Author: your name
 * @Date: 2021-05-17 09:29:53
 * @LastEditTime: 2022-09-15 16:27:41
 * @LastEditors: Smart Chow
 * @Description: In User Settings Edit
 * @FilePath: /nqc-ui/src/frameworks/store/getters.js
 */
const getters = {
  sidebar: (state) => state.app.sidebar,
  language: (state) => state.app.language,
  size: (state) => state.app.size,
  device: (state) => state.app.device,
  navMenus: (state) => state.app.nav_menus,
  notifyCount: (state) => state.app.notifyCount,
  // visitedViews: (state) => state.tagsView.visitedViews,
  // cachedViews: (state) => state.tagsView.cachedViews,
  // token: (state) => state.user.token,
  // avatar: (state) => state.user.avatar,
  userDisplayName: (state) => state.user.loginUserInfo.userDisplayName,
  username: (state) => state.user.loginUserInfo.username, // 获取当前登录用户的登录账号
  loginUserInfo: (state) => state.user.loginUserInfo, // 获取当前登录用户的所有信息
  systemParam: (state) => state.app.systemParam, //系统参数
  // userContextHospital: (state) => state.user.userContextHospital, // 获取当前登录用户的上下文
  // visitHospitalList: (state) => state.user.visitHospitalList, // 获取当前登录用户可切换医院列表
  // userEmpId: (state) => state.user.loginUserInfo.staffCode, // 获取当前登录用户的对应员工id，可能会为null
  // // currentOperatingDeptCode: state => state.user.defaultWorkbench.deptCode, // 获取顶部工具栏所选择的手术科室代码
  // hasContext: (state) => state.user.hasContext,
  // defaultWorkbench: (state) => state.user.defaultWorkbench,
  // userWorkbenchs: (state) => state.user.workbenchs,
  // introduction: (state) => state.user.introduction,
  // status: (state) => state.user.status,
  // roles: (state) => state.user.roles,
  // setting: (state) => state.user.setting,
  // permission_routers: (state) => state.permission.routers,
  // addRouters: (state) => state.permission.addRouters,
  // errorLogs: (state) => state.errorLog.logs,
  selectedFirstLLevelMenuitem: (state) =>
    state.app.selected_firstL_level_menuitem
  // dicts: (state) => state.dictCache.dicts,
  // allUnitList: (state) => state.orgStructure.allUnitList
}
export default getters
